module.exports = "<md-checkbox class=md-primary ng-model=$ctrl.thingPicture ng-change=$ctrl.onChange() aria-label=checkbox> <span class=md-body-1>Has picture</span> </md-checkbox> <md-icon class=\"material-icons material-icons--help\">help</md-icon>";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/search/advanced/thing-picture/thing-picture.html
// module id = 2gIx
// module chunks = 1